import { VOICE_TRANSCRIBE_MOCK_DELAY_MS } from '../model/constants'
/**TODO: Remove this when transcribe feature is implemented */
export const mockTranscribeVoiceMessage = (fileCookie: string): Promise<void> => {
  void fileCookie

  return new Promise((resolve) => {
    window.setTimeout(resolve, VOICE_TRANSCRIBE_MOCK_DELAY_MS)
  })
}
